import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "border rounded-lg" };
const _hoisted_2 = { class: "min-w-full text-center text-sm rounded" };
const _hoisted_3 = {
    scope: "col",
    colspan: "5",
    class: "py pt-2 font-normal text-5xl"
};
const _hoisted_4 = { class: "border-b" };
const _hoisted_5 = {
    colspan: "5",
    class: "whitespace-nowrap pb-2 font-light text-base"
};
const _hoisted_6 = { class: "divide-x font-light" };
const _hoisted_7 = { class: "whitespace-nowrap px-2 py-2 bg-green-100 bg-opacity-50" };
const _hoisted_8 = /*#__PURE__*/ _createElementVNode("br", null, null, -1);
const _hoisted_9 = { class: "whitespace-nowrap px-2 py-2 bg-lime-100 bg-opacity-50" };
const _hoisted_10 = /*#__PURE__*/ _createElementVNode("br", null, null, -1);
const _hoisted_11 = { class: "whitespace-nowrap px-2 py-2 bg-yellow-100 bg-opacity-50" };
const _hoisted_12 = /*#__PURE__*/ _createElementVNode("br", null, null, -1);
const _hoisted_13 = { class: "whitespace-nowrap px-2 py-2 bg-orange-100 bg-opacity-50" };
const _hoisted_14 = /*#__PURE__*/ _createElementVNode("br", null, null, -1);
const _hoisted_15 = { class: "whitespace-nowrap px-1 py-2 bg-red-100 bg-opacity-50" };
const _hoisted_16 = /*#__PURE__*/ _createElementVNode("br", null, null, -1);
import { computed } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'OutstandingRequests',
    props: {
        title: {},
        data: {}
    },
    setup(__props) {
        const props = __props;
        const sum = computed(() => {
            return (props.data?.reduce((accumulator, currentValue) => {
                return accumulator + currentValue;
            }, 0) ?? 0);
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("section", null, [
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("table", _hoisted_2, [
                        _createElementVNode("thead", null, [
                            _createElementVNode("tr", null, [
                                _createElementVNode("th", _hoisted_3, _toDisplayString(sum.value), 1)
                            ])
                        ]),
                        _createTextVNode(),
                        _createElementVNode("tbody", null, [
                            _createElementVNode("tr", _hoisted_4, [
                                _createElementVNode("td", _hoisted_5, "\n                            Outstanding " + _toDisplayString(_ctx.title), 1)
                            ]),
                            _createTextVNode(),
                            _createElementVNode("tr", _hoisted_6, [
                                _createElementVNode("td", _hoisted_7, [
                                    _createElementVNode("strong", null, _toDisplayString(_ctx.data[1]), 1),
                                    _createTextVNode(),
                                    _hoisted_8,
                                    _createTextVNode(" SLA 1\n                        ")
                                ]),
                                _createTextVNode(),
                                _createElementVNode("td", _hoisted_9, [
                                    _createElementVNode("strong", null, _toDisplayString(_ctx.data[2]), 1),
                                    _createTextVNode(),
                                    _hoisted_10,
                                    _createTextVNode("SLA 2\n                        ")
                                ]),
                                _createTextVNode(),
                                _createElementVNode("td", _hoisted_11, [
                                    _createElementVNode("strong", null, _toDisplayString(_ctx.data[3]), 1),
                                    _createTextVNode(),
                                    _hoisted_12,
                                    _createTextVNode("SLA 3\n                        ")
                                ]),
                                _createTextVNode(),
                                _createElementVNode("td", _hoisted_13, [
                                    _createElementVNode("strong", null, _toDisplayString(_ctx.data[4]), 1),
                                    _createTextVNode(),
                                    _hoisted_14,
                                    _createTextVNode("SLA 4\n                        ")
                                ]),
                                _createTextVNode(),
                                _createElementVNode("td", _hoisted_15, [
                                    _createElementVNode("strong", null, _toDisplayString(_ctx.data[5]), 1),
                                    _createTextVNode(),
                                    _hoisted_16,
                                    _createTextVNode("SLA 5+\n                        ")
                                ])
                            ])
                        ])
                    ])
                ])
            ]));
        };
    }
});
